import { render, staticRenderFns } from "./floatingBtn.vue?vue&type=template&id=a6354a28&scoped=true"
import script from "./floatingBtn.vue?vue&type=script&lang=js"
export * from "./floatingBtn.vue?vue&type=script&lang=js"
import style0 from "./floatingBtn.vue?vue&type=style&index=0&id=a6354a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6354a28",
  null
  
)

export default component.exports